export default {
  name: "Nome",
  tel: "Telefono",
  save: "Salva",
  confirm: "Conferma",
  cancel: "Annulla",
  delete: "Elimina",
  loading: "Caricamento in corso...",
  noCoupon: "Nessun coupon",
  nameEmpty: "Inserisci il nome",
  addContact: "Aggiungi contatto",
  telInvalid: "Numero di telefono errato",
  vanCalendar: {
    end: "Fine",
    start: "Inizio",
    title: "Calendario",
    weekdays: [
      "domenica",
      "Lunedi",
      "Martedì",
      "mercoledì",
      "giovedì",
      "venerdì",
      "Sabato"
    ],
    confirm: "confermare",
    startEnd: "Inizia"
  },
  vanCascader: { select: "Seleziona" },
  vanPagination: { prev: "Precedente", next: "Avanti" },
  vanPullRefresh: {
    pulling: "Tiri per aggiornare...",
    loosing: "Largo per rinfrescare..."
  },
  vanSubmitBar: { label: "Totale:" },
  vanCoupon: { unlimited: "Illimitato" },
  vanCouponCell: { title: "Buono", tips: "non disponibile" },
  vanCouponList: {
    exchange: "Scambio",
    close: "Chiudi",
    enable: "Disponibile",
    disabled: "Non disponibile",
    placeholder: "Codice coupon",
    empty: "Nessun coupon"
  },
  vanAddressEdit: {
    area: "Area",
    postal: "Postale",
    areaEmpty: "Seleziona un'area di ricezione",
    addressEmpty: "L'indirizzo non può essere vuoto",
    postalEmpty: "Codice postale errato",
    addressDetail: "Indirizzo",
    defaultAddress: "Imposta come indirizzo predefinito",
    telPlaceholder: "Numero di cellulare del destinatario",
    namePlaceholder: "Nome del destinatario",
    areaPlaceholder: "Seleziona una provincia/città/distretto"
  },
  vanAddressList: { add: "Aggiungi nuovo indirizzo" },
  complete: "Fine",
  telEmpty: "Si prega di compilare il tuo numero di telefono",
  nameInvalid: "Inserisci un nome valido",
  confirmDelete: "Sei sicuro di volerlo eliminarlo",
  vanContactCard: { addText: "Aggiungi un contatto" },
  vanContactList: { addText: "Nuova persona di contatto" },
  vanAddressEditDetail: {
    label: "indirizzo",
    placeholder:
      "Numero della porta di strada, numero di sala da pavimento e altre informazioni"
  }
};
